import WrapperService from '@/modules/core/services/wrapper-service';
import {createPageableParams} from '@/modules/core/services/table-utils';

const settingsServiceName = "Meta-Service: ";
const META_API_URL = process.env.VUE_APP_ROOT_API + '/api/v1/metainfo';

export default class MetaService {

    static async getAllMeta(successF, errorF) {
        await WrapperService.get(META_API_URL, null, settingsServiceName, successF, errorF);
    }

    static async readAllMetasPaginated(page, size, search, sort, sortAsc, successF, errorF) {
        let params = createPageableParams(page, size, search, sort, sortAsc, successF, errorF, ['name'], ['name']);
        await WrapperService.get(META_API_URL + '/page?' + params, null, settingsServiceName, successF, errorF);
    }

    static async saveMeta(meta, successF, errorF) {
        if (typeof meta.id === 'undefined' || meta.id === null) {
            await WrapperService.post(META_API_URL, meta, settingsServiceName, successF, errorF);
        } else {
            await WrapperService.put(META_API_URL + '/' + meta.id, meta, settingsServiceName, successF, errorF);
        }
    }

    static async deleteMeta(id, successF, errorF) {
        await WrapperService.delete(META_API_URL + '/' + id, null, settingsServiceName, successF, errorF);
    }
}